'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const ColorPanel = require('./../../../../bundles/design/repository/DesignRepository');

const Translator = require('./../../../../core/translator');
const FormBuilder = require('./../../builder');

const tplColorPalette = require('./template/color_palette_element.hbs');

let ElementClass = require('./../../elementClass');

FormBuilder.register('color', function(config) {
  let self = {};
  let onChange = config.onChange || jQuery.noop;

  let $colorPaletteElement;

  self = new ElementClass(config);

  self.render = function($wrap) {
    ColorPanel.getAllColors().done(function(data) {
      let colors = data.map((element) => element);

      if (!config.disable_transparent) {
        colors.push({
          'id': '',
          'color': '',
        });
      }

      if (self.config.showPalette) {
        let defaultColor;

        colors.forEach(function(color) {
          if (self.config.value) {
            if (self.config.value === color.id) {
              defaultColor = color.color;
            }
          }
        });

        $colorPaletteElement = jQuery(tplColorPalette({
          'name': self.config.label,
          'value': defaultColor,
        }));

        let $colorInput = $colorPaletteElement.find('.color-palette-element');
        $colorInput.spectrum({
          'preferredFormat': 'hex',
          'allowEmpty': true,
          'showPaletteOnly': true,
          'showPalette': true,
          'clickoutFiresChange': true,
          'palette': colors.map((element) => element.color),
          'change': function(color) {
            let $current = jQuery(this);
            $current.attr('value', color ? color.toHexString() : null);
            self.setColor(color);
          },
          'move': function(color) {
            let $current = jQuery(this);
            $current.attr('value', color ? color.toHexString() : null);
            self.setColor(color);
          },
        });

        let $paletteContainer = $colorInput.spectrum('container');
        defaultColor = defaultColor ? defaultColor : Translator.translate('color_transparent');
        $colorPaletteElement.find('.sp-preview-inner').append('<span>' + defaultColor + '</span>');

        $colorPaletteElement.on('click', function() {
          $colorInput.spectrum('toggle');
          return false;
        });

        $colorInput.on('show.spectrum', function() {
          let $paletteSize = $colorPaletteElement.find('.sp-preview').width();
          let $paletteElements = $paletteContainer.find('.sp-palette-row-0');
          let $colorTransparent = $paletteElements.find('.sp-clear-display');

          $paletteContainer.find('.sp-palette-container').css('width', $paletteSize);
          $colorTransparent.append('<i class="icon icon-ban"></i>');
          $colorInput.val() ? $colorTransparent.addClass('sp-thumb-el') : $colorTransparent.addClass('sp-thumb-el sp-thumb-active');
        });

        $wrap.append($colorPaletteElement);
      } else {
        _.forEach(colors, function(color) {
          let $button = jQuery(`<button data-value="${color.id}" type="button" class="btn btn-default ${color.id}" style="background-color:${color.color}"></button>`);

          if (color.id === '') {
            $button.addClass('button-bg btn-icon-sm').append('<i class="icon icon-ban"></i>');
          }

          if (config.value === color.id || (!config.value && color.id === '')) {
            $button.addClass('selected');
          }

          $button.on('click', (...args) => {
            $wrap.find('button.selected').removeClass('selected');
            $button.addClass('selected');
            onChange.call(this, $button.data('value'), ...args);
          });

          $wrap.append($button).append('&nbsp;');
        });
      }

      if (self.label) {
        $wrap.prepend(`<label class="cloud-label">${self.label}</label>`);
      }
    });
  };

  self.getData = function() {
    if (self.config.showPalette) {
      return self.$.find('input.color-palette-element').val();
    } else {
      return self.$.find('button.selected').data('value') || '';
    }
  };

  self.setColor = function(color) {
    $colorPaletteElement.find('.color-palette-element').spectrum('hide');
    $colorPaletteElement.find('.sp-preview-inner span').text(
      color ? color.toHexString() : Translator.translate('color_transparent'),
    );
  };

  return self;
});
